export const sources = {
  PROJECT_MENU: 'uf.header.project_menu',
};
